var dropdownItems;
export async function initDropDown(dropDownSettings) {
    dropdownItems = await dropDownGenerate(dropDownSettings);
    return dropdownItems;
}
function dropDownGenerate(selectSettings) {
    var dropDownKeysData = Object.keys(selectSettings.settings);
    let dropDownData = selectSettings.settings;
    for (let i = 0; i < dropDownKeysData.length; i++) {
        const el = dropDownKeysData[i];
        let options = {
            id: dropDownData[el].id,
            name: dropDownData[el].name,
            class: dropDownData[el].class,
            child: dropDownData[el].child
        };
        let selectElement = createSelectElement(options, selectSettings.callback);
        dropDownData[el].data.length > 0 ? selectElement.disabled = false : selectElement.disabled = true;
        dropDownData[el].element = selectElement;
        addOptionToSelect(dropDownData[el].element, dropDownData[el].placeholder);
        let dropDownSettings = {
            parentSelect: dropDownData[el].element,
            data: dropDownData[el].data,
            id: 'id',
            value: 'value'
        };
        dropDownData[el].data.length > 0 ? bindOptionToSelect(dropDownSettings) : null;
    }
    return dropDownData;
}
export function bindOptionToSelect(optionsSelect) {
    let option = null;
    removeSelectOptions(optionsSelect.parentSelect);
    if (optionsSelect.placeHolderTxt != null) {
        let optionPlaceHolder = document.createElement("option");
        optionPlaceHolder.value = "";
        optionPlaceHolder.text = optionsSelect.placeHolderTxt;
        optionsSelect.parentSelect.appendChild(optionPlaceHolder);
    }
    for (let index = 0; index < optionsSelect.data.length; index++) {
        const el = optionsSelect.data[index];
        option = document.createElement("option");
        option.value = el['id'];
        option.text = el['value'];
        optionsSelect.parentSelect.appendChild(option);
    }
    optionsSelect.parentSelect.options.length > 1 ? optionsSelect.parentSelect.disabled = false : optionsSelect.parentSelect.disabled = true;
}
function createSelectElement(options, callback) {
    let el = document.createElement('select');
    el.data = options.child || null;
    el.name = options.name || null;
    el.id = options.id || null;
    el.className = options.class || null;
    el.onchange = callback;
    return el;
}
function addOptionToSelect(el, colTxt) {
    const option = document.createElement('option');
    option.value = "";
    option.text = colTxt;
    el.appendChild(option);
}
export function addWrapperForSelect(selectWrapper, uniqVal) {
    debugger;
    //let wraperSelect: any = document.querySelector(`#wraper-select-${uniqVal}`);
    let wraperSelect = document.querySelector(`#wraper-select-${uniqVal}`);
    if (!wraperSelect) {
        wraperSelect = document.createElement('div');
        wraperSelect.id = `wraper-select-${uniqVal}`;
        wraperSelect.className = "input-group mt-1";
        //wraperSelect.style.width = "100%";
        //wraperSelect.style.textAlign = selectWrapper.textAlign;
        selectWrapper.parent.appendChild(wraperSelect);
    }
    return wraperSelect;
}
export function addLabelForSelect(parent, id, lblTxt) {
    const lbl = document.createElement('label');
    lbl.htmlFor = id;
    lbl.textContent = lblTxt;
    lbl.className = "col-12";
    // lbl.style.fontWeight = 'bold';
    lbl.style.alignItems = "right";
    parent.appendChild(lbl);
}
export function removeSelectOptions(element) {
    if (dropdownItems) {
        let allDropDownParent = Object.keys(dropdownItems);
        let findItemByIndex = allDropDownParent.findIndex((el) => el === element.id);
        if (findItemByIndex != -1) {
            for (let index = findItemByIndex; index < allDropDownParent.length; index++) {
                const el = dropdownItems[allDropDownParent[index]];
                console.log(el);
                var select = el;
                select.element.selectedIndex = 0;
                select.element.disabled = true;
                if (select.element.options.length > 1) {
                    var length = select.element.options.length;
                    for (let i = length - 1; i >= 1; i--) {
                        select.element.options[i] = null;
                    }
                }
                if (el.child === "") {
                    return false;
                }
            }
        }
    }
}
// export function disableAllChildElement() {
//     if (dropdownItems) {
//         let parents = Object.keys(dropdownItems);
//         for (let index = 0; index < parents.length; index++) {
//             const el = parents[index];
//             let Child = dropdownItems[el].child;
//             dropdownItems[Child].data.length > 0 ? undefined : dropdownItems[Child].element.disabled = true;
//         }
//         debugger
//         console.log(dropdownItems);
//     }
// }
